<template>
  <div class="wrap">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>授权管理</span>
      </div>
      <!-- tableData -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="日期" width="310">
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="310">
        </el-table-column>
        <el-table-column prop="address" label="地址" width="310">
        </el-table-column>
        <el-table-column prop="time" label="时间" width="310">
        </el-table-column>
      </el-table>
    </el-card>
    <pagination style="textAlign:center;marginTop:40px;" :current_page="1" :total="50"></pagination>
  </div>
</template>

<script>
// @ts-nocheck
import pagination from "@/components/Pagination/index.vue";
export default {
  components: {
    pagination,
  },
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          time: "1999-9-9",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
          time: "1999-9-9",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
          time: "1999-9-9",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
          time: "1999-9-9",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  height: 600px;
  display: flex;
  flex-direction: column;
  .box-card{
    height: 600px;
  }
}
</style>